import { useEffect, useState } from 'react';

function calcularIdade(dataNasc) {
  const hoje = new Date();
  const nasc  = new Date(dataNasc);
  let idade = hoje.getFullYear() - nasc.getFullYear();
  const m = hoje.getMonth() - nasc.getMonth();
  if (m < 0 || (m === 0 && hoje.getDate() < nasc.getDate())) idade--;
  return idade;
}

const HOBBIES = [
  'Ensinar inglês e desenvolver métodos de ensino',
  'Assistir filmes e séries em inglês',
  'Ouvir música internacional',
  'Ler revistas e livros em inglês',
  'Ajudar pessoas a aprender de forma divertida',
];

const SOCIAL = [
  { href: 'https://github.com/dionicosta/dionicosta',                       icon: 'fab fa-github',   label: 'GitHub'    },
  { href: 'https://www.linkedin.com/feed/?trk=nav_back_to_linkedin',        icon: 'fab fa-linkedin', label: 'LinkedIn'  },
  { href: 'https://www.instagram.com/dionioseuprofessordeingles/',           icon: 'fab fa-instagram',label: 'Instagram' },
  { href: 'https://www.youtube.com/@dionioseuprofessordeingles4476',         icon: 'fab fa-youtube',  label: 'YouTube'   },
  { href: 'https://wa.me/5511913255371',                                     icon: 'fab fa-whatsapp', label: 'WhatsApp'  },
];

export default function Sobre() {
  const [visible, setVisible] = useState(false);
  const idade = calcularIdade('1987-09-17');

  useEffect(() => {
    // Trigger fade-in on mount
    const t = setTimeout(() => setVisible(true), 60);
    return () => clearTimeout(t);
  }, []);

  function scrollTop() { window.scrollTo({ top: 0, behavior: 'smooth' }); }

  return (
    <div style={{
      background: 'linear-gradient(135deg, #f0f4f8, #dce8f5)',
      minHeight: 'calc(100vh - 66px)',
      padding: '40px 20px 80px',
      fontFamily: 'Poppins, sans-serif',
    }}>

      <div style={{
        maxWidth: 800,
        margin: '0 auto',
        background: '#fff',
        borderRadius: 24,
        padding: '40px 36px',
        boxShadow: '0 10px 40px rgba(0,0,0,0.10)',
        textAlign: 'center',
        opacity: visible ? 1 : 0,
        transform: visible ? 'translateY(0)' : 'translateY(32px)',
        transition: 'opacity 0.9s ease, transform 0.9s ease',
      }}>

        {/* Foto */}
        <img
          src="/assets/perfil.jpg"
          alt="Dionísio"
          style={{
            width: 160, height: 160,
            objectFit: 'cover',
            borderRadius: '50%',
            border: '5px solid #1e90ff',
            marginBottom: 20,
            boxShadow: '0 6px 24px rgba(30,144,255,0.25)',
          }}
        />

        <h1 style={{ fontSize: '2rem', fontWeight: 800, color: '#1a2a4a', marginBottom: 6 }}>
          Dionísio
        </h1>
        <p style={{ color: '#90a4ae', fontSize: '1rem', marginBottom: 32, fontWeight: 400 }}>
          Professor de Inglês · {idade} anos
        </p>

        {/* Divisor */}
        <div style={{ width: 60, height: 4, background: 'linear-gradient(90deg,#1e90ff,#16c2fb)', borderRadius: 2, margin: '0 auto 36px' }} />

        {/* Sobre Mim */}
        <div style={{ textAlign: 'left', marginBottom: 36 }}>
          <h2 style={{ color: '#1e90ff', fontSize: '1.3rem', fontWeight: 700, marginBottom: 16, display: 'flex', alignItems: 'center', gap: 8 }}>
            <i className="fas fa-user-circle" /> Sobre Mim
          </h2>
          {[
            'Eu amo o inglês. Comecei a aprender em 2004, em Luanda, Angola. Na época havia muito poucas escolas de inglês. Então comecei a aprender por conta própria. Tive um professor incrível por apenas uma semana — mas o que ele me ensinou mudou minha vida.',
            'Me agarrei totalmente ao folheto que ele me deu até memorizar tudo. Em 2005, sem poder ir logo para o ensino médio, investi pesado: assistia filmes, ouvia música e lia tudo que encontrava em inglês.',
            'Tinha um desafio: não tinha pessoas para praticar. Solução criativa: eu ficava falando sozinho, inventando personagens — era o moço que perguntava E a moça que respondia ao mesmo tempo! 🤣',
            'Em 2006 entrei no ensino médio e comecei a praticar com colegas. Pegava dicionário emprestado e ficava a noite inteira anotando palavras. Em 2007-2008 já me comunicava bem e fui convidado a dar aulas em uma escola particular.',
            'Em 2012, trabalhando em uma grande empresa com engenheiros estrangeiros que só falavam inglês, pratiquei o idioma todos os dias por 4 anos. Em 2017 comecei a dar aulas online e desenvolvi meus próprios métodos para tornar o aprendizado mais fácil, claro e acelerado.',
            'Já são quase 8 anos ensinando inglês online. Uma história maravilhosa, cheia de boas memórias. Muito obrigado ao professor que nunca mais vi — e muito obrigado a você por essa visita! God bless us! 🙏',
          ].map((p, i) => (
            <p key={i} style={{ color: '#555', fontSize: '0.97rem', lineHeight: 1.85, marginBottom: 14, fontWeight: 400 }}>
              {p}
            </p>
          ))}
        </div>

        {/* Interesses */}
        <div style={{ textAlign: 'left', marginBottom: 36 }}>
          <h2 style={{ color: '#1e90ff', fontSize: '1.3rem', fontWeight: 700, marginBottom: 16, display: 'flex', alignItems: 'center', gap: 8 }}>
            <i className="fas fa-star" /> Interesses & Hobbies
          </h2>
          <ul style={{ listStyle: 'none', padding: 0, margin: 0, display: 'flex', flexDirection: 'column', gap: 10 }}>
            {HOBBIES.map(h => (
              <li key={h} style={{ display: 'flex', alignItems: 'flex-start', gap: 10, color: '#555', fontSize: '0.95rem', fontWeight: 400 }}>
                <span style={{ color: '#1e90ff', flexShrink: 0, marginTop: 2 }}>
                  <i className="fas fa-check-circle" />
                </span>
                {h}
              </li>
            ))}
          </ul>
        </div>

        {/* Redes sociais */}
        <div style={{ marginBottom: 8 }}>
          <h2 style={{ color: '#1e90ff', fontSize: '1.3rem', fontWeight: 700, marginBottom: 18, display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 8 }}>
            <i className="fas fa-share-alt" /> Redes Sociais
          </h2>
          <div style={{ display: 'flex', justifyContent: 'center', gap: 16, flexWrap: 'wrap' }}>
            {SOCIAL.map(s => (
              <a
                key={s.label}
                href={s.href}
                target="_blank"
                rel="noreferrer"
                title={s.label}
                style={{
                  width: 48, height: 48,
                  borderRadius: '50%',
                  background: 'linear-gradient(135deg, #1e90ff, #16c2fb)',
                  color: '#fff',
                  display: 'flex', alignItems: 'center', justifyContent: 'center',
                  fontSize: '1.2rem',
                  textDecoration: 'none',
                  boxShadow: '0 4px 14px rgba(30,144,255,0.3)',
                  transition: 'transform 0.2s, box-shadow 0.2s',
                }}
                onMouseEnter={e => { e.currentTarget.style.transform = 'scale(1.15) translateY(-3px)'; e.currentTarget.style.boxShadow = '0 8px 22px rgba(30,144,255,0.45)'; }}
                onMouseLeave={e => { e.currentTarget.style.transform = 'scale(1) translateY(0)';       e.currentTarget.style.boxShadow = '0 4px 14px rgba(30,144,255,0.3)'; }}
              >
                <i className={s.icon} />
              </a>
            ))}
          </div>
        </div>

        <footer style={{ marginTop: 40, color: '#bbb', fontSize: '0.82rem', fontWeight: 400 }}>
          © {new Date().getFullYear()} Inglês do Dionísio — Feito com ❤️
        </footer>
      </div>

      {/* Botão voltar ao topo */}
      <button
        onClick={scrollTop}
        title="Voltar ao topo"
        style={{
          position: 'fixed', bottom: 92, right: 28,
          width: 44, height: 44, borderRadius: '50%',
          background: 'linear-gradient(135deg, #1e90ff, #16c2fb)',
          border: 'none', color: '#fff', fontSize: '1rem',
          cursor: 'pointer', boxShadow: '0 4px 14px rgba(30,144,255,0.35)',
          transition: 'transform 0.2s',
          zIndex: 97,
          fontFamily: 'inherit',
        }}
        onMouseEnter={e => e.currentTarget.style.transform = 'scale(1.12)'}
        onMouseLeave={e => e.currentTarget.style.transform = 'scale(1)'}
      >
        <i className="fas fa-arrow-up" />
      </button>
    </div>
  );
}
